export type EventDataKey = "errorMessage";

export type CustomEventProperties = Partial<
  Record<EventDataKey, string | number | boolean | undefined>
>;

export enum AnalyticsEvent {
  // Errors
  formDecodeError = "Error_FormDecode",
  documentDownloadError = "Error_DocumentDownload",
  documentDownloadNetworkError = "Error_DocumentDownloadNetwork",
  formDataSavingError = "Error_FormDataSaving",

  // Form Api Responses
  accessAttemptsExceededResponse = "Response_AccessAttemptsExceeded",
  formExpiredResponse = "Response_FormExpired",
  alreadyCompletedResponse = "Response_AlreadyCompleted",
  pinRequiredResponse = "Response_PinRequired",
  formCancelledResponse = "Response_FormCancelled",
  notFoundResponse = "Response_NotFound"
}
